import { render, staticRenderFns } from "./TargetDateEditor.vue?vue&type=template&id=879bd10c&"
import script from "./TargetDateEditor.vue?vue&type=script&lang=ts&"
export * from "./TargetDateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports